import React, { ReactNode } from 'react'
import { Layout, Row, Col } from 'antd'
import styles from './AnalyticsLayout.module.scss'

export interface AnalyticsLayoutProps {
  globalContent?: ReactNode
  navigationContent?: ReactNode
  children: ReactNode
}

const AnalyticsLayout: React.FC<AnalyticsLayoutProps> = ({
   globalContent,
   navigationContent,
   children,
 }) => {
  return (
    <Layout className={`${styles.analyticsLayout}`}>
      <div className={styles.topSection}>
        <Row className={styles.topRow} gutter={[0, 0]}>
          <Col span={2} className={styles.globalSection}>
            <div className={styles.globalSectionContent}>
              {globalContent}
            </div>
          </Col>

          <Col span={21} style={{ height: '100%' }}>
          </Col>
        </Row>
      </div>

      <div className={styles.bottomSection}>
        <Row className={styles.bottomRow} gutter={[0, 0]}>
          <Col span={2} className={styles.navigationSection}>
            <div className={styles.navigationSectionContent}>
              {navigationContent}
            </div>
          </Col>

          <Col span={21} style={{ height: '100%' }}>
          </Col>
        </Row>
      </div>

      <div style={{
        position: 'absolute',
        top: '0',
        left: '8.3%',
        right: '0',
        bottom: '0',
        zIndex: 1
      }}>
        {children}
      </div>

    </Layout>
  )
}

export default AnalyticsLayout
